import WorkInfo from './WorkInfo'

export default WorkInfo
